import { Card, CardHeader, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import _ from "lodash";
import Swal from "sweetalert2";
import { allDepartments, deleteDepartment } from "./departmentData";
import URL from "../../../pages/Utils/url";
import request from "graphql-request";
import BASEURL from "../../../pages/Utils/Baseurl";
import { useMutation } from "@apollo/client";
import { useLoading } from "../../../context/LodingContext";
import { downloadExcelFile } from "../../function/downloadExcel";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";
import RoleAccess from "../../function/RoleAccess";
import { showUploadDialog } from "../../../components/uploadDialog/ExcelUploadDialog";
import { FileUploadModal } from "../../../components/uploadDialog/FileUploadModal";
import TableComponents from "../../../../src/components/tabel/index";

const DepartmentMaster = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // const [UpdateFile] = useMutation(uploadProductMaster);
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const { userId } = useAuthData();
  const [uploadStatus, setUploadStatus] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [dataCount, setDataCount] = useState({
    pageCount: 0,
    itemCount: 0,
  });

  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    fetchdata();
  }, [pagination, searchValue]);

  const DepartmentMasterListTable = {
    columns: [
      {
        header: "Department Name",
        accessorKey: "departmentName",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      // {
      //   header: "Create By",
      //   accessorKey: "createdBy",
      //   cell: (props) => <p>{props?.getValue()}</p>,
      // },
      // {
      //   header: "Create Date",
      //   accessorKey: "createdAt",
      //   cell: (props) => <p>{props?.getValue()}</p>,
      // },
      {
        header: "Action",
        accessorKey: "Action",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
    ],
    rows: data.map((v, i) => ({
      sno: i + 1,
      id: v.id,
      departmentName: v?.departmentName,
      // createdBy: v?.user?.employeeName,
      // createdAt: v?.createdAt?.slice(0, 10),

      Action: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <RoleAccess
            modelName="Department Master Screen"
            component="ViewDepartmentMaster"
          >
            <VisibilityIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/department-masters/view-department-master`, {
                  state: { type: "view", data: v, rowId: v?.id },
                })
              }
            />
          </RoleAccess>

          <RoleAccess
            modelName="Department Master Screen"
            component="UpdateDepartmentMaster"
          >
            <EditIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/department-masters/edit-department-master`, {
                  state: { type: "edit", data: v, rowId: v?.id },
                })
              }
            />
          </RoleAccess>
          <RoleAccess
            modelName="Department Master Screen"
            component="DeleteDepartmentMaster"
          >
            <DeleteIcon
              fontSize="small"
              className="actionIcon"
              onClick={() => handleDelete(v?.id)}
            />
          </RoleAccess>
        </div>
      ),
    })),
  };

  const fetchdata = async (searchText = "") => {
    setIsLoading(true);

    try {
      const res = await request(BASEURL, allDepartments, {
        page: pagination.pageIndex + 1,
        pageSize: pagination.pageSize,
        search: searchValue,
      });

      const success = res?.allDepartments?.success;
      const message = res?.allDepartments?.message;

      if (success) {
        let newdata = res?.allDepartments?.data || [];

        if (searchText !== "") {
          newdata = newdata.filter((item) =>
            item?.departmentName
              ?.toLowerCase()
              .includes(searchText.toLowerCase()),
          );
        }

        setData(newdata);

        setDataCount({
          itemCount: res?.allDepartments?.totalCount,
          pageCount: res?.allDepartments?.totalPages,
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });

        setData([]);
        setDataCount({ itemCount: 0, pageCount: 0 });
      }
    } catch (err) {
      const message =
        err?.response?.errors?.message ||
        err?.message ||
        "Something went wrong";

      Swal.fire({
        position: "top",
        icon: "error",
        title: message,
        showConfirmButton: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure you want to delete this data?",
      text: "This action is irreversible and cannot be recovered.",
      icon: "question",
      showCancelButton: true,
    }).then(async (result) => {
      if (result?.isConfirmed) {
        setCirleLoading(true);
        try {
          const res = await request(BASEURL, deleteDepartment, {
            "departmentId": id,
          });

          const success = res?.deleteDepartment?.success;
          const message = res?.deleteDepartment?.message;
          if (success) {
            Swal.fire({
              position: "top",
              icon: "success",
              title: message,
              showConfirmButton: true,
            }).then(() => {
              fetchdata();
            });
          } else {
            Swal.fire({
              position: "top",
              icon: "error",
              title: message,
              showConfirmButton: true,
            });
          }
        } catch (err) {
        } finally {
          setCirleLoading(false);
        }
      }
    });
  };

  const handleSearch = (searchValue) => {
    setSearchValue(searchValue);
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Department Master List
                </MaterialTypography>
              </Stack>

              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() =>{
                  
                  navigate("/department-masters/add-department-master", {
                    state: { type: "add" },
                  })
                }
                }
              >
                Department Master
              </MaterialButton>
            </Stack>
          }
        />

        <>
          <TableComponents
            rows={DepartmentMasterListTable?.rows}
            columns={DepartmentMasterListTable?.columns}
            pagination={pagination}
            setPagination={setPagination}
            pageCount={dataCount.pageCount}
            onChange={handleSearch}
            recordCount={dataCount.itemCount}
            isLoading={isLoading}
            isSearch={true}
          />
        </>
      </Card>
    </DashboardLayout>
  );
};

export default DepartmentMaster;
